import React from 'react'
export default function ContactForm(){
    const [formStatus, setFormStatus] = React.useState('Send')
    const onSubmit = (e) => {
      e.preventDefault()
      setFormStatus('Submitting...')
      const { name, email, job, message } = e.target.elements
      let conFom = {
        name: name.value,
        email: email.value,
        message: message.value,
        job:job.value,
      }  
    }
    return(
        <form className="row contact-form mb-30" onSubmit={onSubmit}>
            <div className="col-lg-6 col-md-6">
                <div className="input-box mb-20">
                    <input type="text" name="name" placeholder="Full name **" />
                </div>
            </div>
            <div className="col-lg-6 col-md-6">
                <div className="input-box mail-input mb-20">
                    <input type="text"  name="email" placeholder="Email address **" />
                </div>
            </div>
            <div className="col-lg-12 mb-20">
                <div className="input-box sub-input">
                    <select name="job" className="job-select">
                        <option value="Subject">Subject</option>
                        <option value="">It</option>
                        <option value="">Development</option>
                        <option value="">Ui/Ux</option>
                    </select>
                </div>
            </div>
            <div className="col-12">
                <div className="input-box text-input mb-15">
                    <textarea name="message" cols="30" rows="10"
                        placeholder="Enter massge **"></textarea>
                </div>
            </div>
            <div className="col-12">
                <button className="form-btn form-btn3">Get Free Consultation</button>
            </div>
        </form>
    )
}
